(function(algolia) {
    'use strict';
  
  
    algolia.full_results = Boolean(window.location.href.match(/\/search/));
  
    // We want to match `/collections/handle` but only if handle != 'all'
    algolia.is_collection_results_page = Boolean(
      window.location.pathname.match(/^\/collections\/(?!all$)([^/]+)[/]*$/)
      /**
       * To match /collections/handle/handle-two links as well, please use
       * the following regex instead:
       */
      // window.location.pathname.match(/^\/collections\/(?!all)(.*)$/)
    );
  
  
    if (
    (algolia.full_results || algolia.is_collection_results_page) ||
      !algolia.config.instant_search_enabled
    ) {
      return;
    }
  
    
    const suggestions = instantsearch({
        indexName: algolia.config.index_prefix + 'products',
        // searchClient: algoliasearch("UB7AEJB05A", "bf128b0977a6d8f598f8007a831f45a5"),
        searchClient: algoliasearch(
          algolia.config.app_id,
          algolia.config.search_api_key
        ),
        
        
    });
    
   
    const handelize = (str) => {
      if (str !== undefined)
      return str.replace(/[^a-z0-9]+/gi, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '')
      .toLowerCase();
      else
          return 'all';
    }
    
   // Helper for the render function
  const renderIndexListItem = ({ indexId, hits }) => `
  
        ${hits
          .map(
            (item, hitIndex) =>
              `
                  <a href="/collections/${handelize(item.vendor)}/products/${ item.handle }?variant=${item.objectID}" class="search-bar__result-item">
                    <div class="search-bar__image-container">
                      <div class="aspect-ratio aspect-ratio--square">
                        <img src=${item.image} 200w, ${item.image}, 300w" alt="${item.title} ${item.options.color}">
                      </div>
                    </div>
  
                    <div class="search-bar__item-info">
                      <p class="search-bar__item-title">${item.title} ${item.options.color}</p>
                      <span class="search-bar__item-price">$${unit_pricing(item.price, item.meta)}/${item.meta.pricing.price_uom.toLowerCase()}</span>
                    </div>
                  </a>
                  
              `
          )
          .join('')}
  `;
  
  // Create the render function
  const renderAutocomplete = (renderOptions, isFirstRender) => {
    const { indices, currentRefinement, refine, widgetParams } = renderOptions;
  
  
    // console.log(indices, 'indices');
    // console.log(currentRefinement, 'currentRefinement');
    // console.log(refine, 'refine');
    // console.log(widgetParams,'widgetParams');
  
    if (isFirstRender)
    {
      const heading = document.createElement('p');
        heading.classList.add('search-bar__result-category');
        heading.innerHTML = 'Products';
        const inner_div = document.createElement('div');
        inner_div.classList.add('search-bar__result-products');
        const footer = `<a class="search-bar__view-all" href="/search?q=${currentRefinement}&type=product">
                        View all results
                        <svg class="icon icon--arrow-right" viewBox="0 0 8 12" role="presentation">
                          <path stroke="currentColor" stroke-width="2" d="M2 2l4 4-4 4" fill="none" stroke-linecap="square"></path>
                        </svg>
                      </a>
                        `;
    
  
      widgetParams.container.appendChild(heading);
        widgetParams.container.appendChild(inner_div);
        widgetParams.container.innerHTML += footer;
  
      document.querySelector('.search-bar__results').setAttribute('aria-hidden', 'true');
      document.querySelector('.search-bar__menu-wrapper').setAttribute('aria-hidden', 'true');
  
      console.log("first render" + currentRefinement.length);
  
    }
  
    if (currentRefinement.length <= 0)
    {
    
      return;
    }
  
      document.querySelector('.search-bar__results').classList.remove('is-loading');
      widgetParams.container.querySelector('.search-bar__result-products').innerHTML = indices
        .map(renderIndexListItem)
        .join('');
      widgetParams.container.querySelector('.search-bar__view-all').href = `/search?q=${currentRefinement}&type=product`;
      
  };
  
  // Create the custom widget
  const customAutocomplete = instantsearch.connectors.connectAutocomplete(
    renderAutocomplete
  );
  
  // Instantiate the custom widget
  suggestions.addWidgets([
    
    instantsearch.widgets.configure({
      hitsPerPage: 3,
    }),
  
    customAutocomplete({
      container: document.querySelector('.search-bar__results-inner'),
    })
  ]);
    
    // search hook
  
    // Create a render function
    const renderSearchBox = (renderOptions, isFirstRender) => {
      const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;
  
      if (isFirstRender) {
          const inputbox = document.getElementsByClassName('search-bar__input')[0];
  
  
          inputbox.addEventListener('input', event => {
              if (event.target.value === '')
              {
                document.querySelector('.search-bar__results').setAttribute('aria-hidden', 'true');
                document.querySelector('.search-bar__menu-wrapper').setAttribute('aria-hidden', 'false');
              }
              else
              {
                document.querySelector('.search-bar__results').setAttribute('aria-hidden', 'false');
                document.querySelector('.search-bar__results').classList.add('is-expanded', 'is-loading');
                document.querySelector('.search-bar__menu-wrapper').setAttribute('aria-hidden', 'true');
  
              }
              refine(event.target.value);
          });
      }
  
  
      document.getElementsByClassName('search-bar__input')[0].value = query;
      // widgetParams.container.querySelector('span').hidden = !isSearchStalled;
  };
  
    // create custom widget
    const customSearchBox = instantsearch.connectors.connectSearchBox(
        renderSearchBox
    );
  
    // instantiate custom widget
    suggestions.addWidgets([
        customSearchBox({
          container: document.querySelector('#search-box-container'),
        })
    ]);
   
    suggestions.start();
  })(window.algoliaShopify);